import React from 'react';
import { PriceList } from './components/PriceList';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen bg-bg-surface font-jakarta" data-id="element-0">
      <PriceList data-id="element-1" />
      <Footer data-id="element-2" />
    </div>;
}